import { useEffect, useState } from "react"
import { SingleCheckbox } from "../../../../../ui/molecules/SingleCheckbox"
import { addIVUpdateDefaultStartingEndingVisits, setIVUpdateActivity, setIVUpdateAdministrativeVerification, setIVUpdateAuditedActivities, setIVUpdateDaysNumber, setIVUpdateDocumentalControl, setIVUpdateEffectiveVisitDate, setIVUpdateExclusionDate, setIVUpdateExclusionProtocolId, setIVUpdateExpertSubject, setIVUpdateExpirationDate, setIVUpdateExpirationDateExtended, setIVUpdateInAccompanyingSubject, setIVUpdateInAccompanyingSubjectEntity, setIVUpdateInLocoControl, setIVUpdateInMoreDays, setIVUpdateInstructorNote, setIVUpdateInSupportSubject, setIVUpdateInSupportSubjectEntity, setIVUpdateIsNotPerformed, setIVUpdateIsReportReturned, setIVUpdateIsRevoked, setIVUpdateMode, setIVUpdateNonComplianceType, setIVUpdateNote, setIVUpdatePlannedVisitDate, setIVUpdateRemoteVisit, setIVUpdateReportProtocolId, setIVUpdateRestitutionProtocolId, setIVUpdateResult, setIVUpdateReturnedReportProtocolId, setIVUpdateRevokedProtocolId, setIVUpdateSpecification, setIVUpdateStartingEndingVisits, setIVUpdateTraineeTechniciant, setIVUpdateType, setIVUpdateVisitDate } from "../../../slice"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { IVAuditedActivityEnum } from "../../../dataservice/dto"
import { SelectCustom } from "../../../../../ui/molecules/select"
import { formatterDate, IVActivityOptions, IVControlResultOptions, IVModeOptions, IVNonComplianceTypeOptions, IVTypeOptions, OptionType } from "../../../../../utils"
import { Calendar } from "../../../../../ui/molecules/calendar"
import { InfoBox } from "../../../../../ui/molecules/infoBox"
import TextArea from "../../../../../ui/molecules/textArea"
import { ProtocolSearch } from "../../../../../ui/molecules/ProtocolSearch"
import Button from "../../../../../ui/molecules/button"
import { RoundedPlusIcon } from "../../../../../ui/icons/RoundedPlusIcon"
import { TableSelect } from "../../../../../ui/molecules/tableSelect"
import { EditIcon } from "../../../../../ui/icons/edit"
import { PopupForm } from "../../../../../ui/organisms/popupForm"
import { IVHoursPopupEdit, IVHoursPopupAdd } from "./hoursPopup"
import { TrashIcon } from "../../../../../ui/icons/trash"
import Input from "../../../../../ui/molecules/input"
import { getOptions } from "../../../utils"
import { format } from "date-fns"

export function IVGestioneControlloEdit() {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const [inLocoFlag, setInLocoFlag] = useState<boolean>(false)
    const [documentalFlag, setDocumentalFlag] = useState<boolean>(false)
    const [remoteFlag, setRemoteFlag] = useState<boolean>(false)
    const [bioHarvFlag, setBioHarv] = useState<boolean>(false)
    const [demeterFlag, setDemeterFlag] = useState<boolean>(false)
    const [bioSuisseFlag, setBioSuisseFlag] = useState<boolean>(false)
    const [inMoreDaysFlag, setInMoreDaysFlag] = useState<boolean>(false)
    const [visitToEdit, setVisitToEdit] = useState<string | null>(null)
    const [isRevokedFlag, setIsRevokedFlag] = useState<boolean>(false)
    const [isNotPerformedFlag, setIsNotPerformedFlag] = useState<boolean>(false)
    const [isReportReturnedFlag, setIsReportReturnedFlag] = useState<boolean>(false)
    const [admVerificationFlag, setAdmVerificationFlag] = useState<boolean>(false)
    const [showPopupAdd, setShowPopupAdd] = useState<boolean>(false)
    const [showPopupEdit, setShowPopupEdit] = useState<boolean>(false)

    useEffect(() => {
        const req = assignmentState.inspectionVisitUpdateRequest
        setInLocoFlag(req.inLocoControl !== undefined ? req.inLocoControl : false)
        setDocumentalFlag(req.documentalControl !== undefined ? req.documentalControl : false)
        setRemoteFlag(req.remoteVisit !== undefined ? req.remoteVisit : false)
        setBioHarv(req.auditedActivities.includes(IVAuditedActivityEnum.AGRICOLTURA_BIOLOGICA))
        setDemeterFlag(req.auditedActivities.includes(IVAuditedActivityEnum.DEMETER))
        setBioSuisseFlag(req.auditedActivities.includes(IVAuditedActivityEnum.BIO_SUISSE))
        setInMoreDaysFlag(req.inMoreDays !== undefined ? req.inMoreDays : false)
        setIsRevokedFlag(req.isRevoked !== undefined ? req.isRevoked : false)
        setIsNotPerformedFlag(req.isNotPerformed !== undefined ? req.isNotPerformed : false)
        setIsReportReturnedFlag(req.isReportReturned !== undefined ? req.isReportReturned : false)
        setAdmVerificationFlag(req.administrativeVerification !== undefined ? req.administrativeVerification : false)
    }, [assignmentState.inspectionVisitUpdateRequest])

    return (
        <div style={{ padding: '0px 24px 24px 24px' }}>
            <div className="assignment-container">
                <div className="assignment-header text-left">
                    <span className='assignment-title-bold' style={{ color: '#fff' }}>Visite Ispettive </span>
                    <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                    <span className='assignment-title-bold' style={{ color: '#d9e6e8' }}> CDX VVI - Verbale di Visita Ispettiva (Controllo)</span>
                </div>

                <div style={{ padding: '24px' }}>
                    <div style={{ display: 'flex', rowGap: '0px', columnGap: '48px', flexWrap: 'wrap' }}>
                        <div>
                            <div className="pb-1 text-left assignment-subtitle">
                                Tipo di Controllo
                            </div>

                            <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                    <div className='text-left assignment-text-content'>
                                        Controllo in Loco
                                    </div>
                                    <SingleCheckbox
                                        label=''
                                        checked={inLocoFlag}
                                        setChecked={(value) => {
                                            dispatch(setIVUpdateInLocoControl(value))
                                            setInLocoFlag(value)
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                    <div className='text-left assignment-text-content'>
                                        Controllo Documentale
                                    </div>
                                    <SingleCheckbox
                                        label=''
                                        checked={documentalFlag}
                                        setChecked={(value) => {
                                            dispatch(setIVUpdateDocumentalControl(value))
                                            setDocumentalFlag(value)
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                    <div className='text-left assignment-text-content'>
                                        Controllo da remoto
                                    </div>
                                    <SingleCheckbox
                                        label=''
                                        checked={remoteFlag}
                                        setChecked={(value) => {
                                            dispatch(setIVUpdateRemoteVisit(value))
                                            setRemoteFlag(value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="pb-1 text-left assignment-subtitle">
                                Controlli aggiuntivi
                            </div>

                            <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                    <div className='text-left assignment-text-content'>
                                        Demeter
                                    </div>
                                    <SingleCheckbox
                                        label=''
                                        checked={demeterFlag}
                                        setChecked={(value) => {
                                            let newActTypes: IVAuditedActivityEnum[] = [...assignmentState.inspectionVisitUpdateRequest.auditedActivities]
                                            if (value && !newActTypes.includes(IVAuditedActivityEnum.DEMETER)) {
                                                newActTypes.push(IVAuditedActivityEnum.DEMETER)
                                            }
                                            else if (!value && newActTypes.includes(IVAuditedActivityEnum.DEMETER)) {
                                                newActTypes = newActTypes.filter(a => a !== IVAuditedActivityEnum.DEMETER)
                                            }
                                            dispatch(setIVUpdateAuditedActivities(newActTypes))
                                            setDemeterFlag(value)
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                    <div className='text-left assignment-text-content'>
                                        Bio Suisse
                                    </div>
                                    <SingleCheckbox
                                        label=''
                                        checked={bioSuisseFlag}
                                        setChecked={(value) => {
                                            let newActTypes: IVAuditedActivityEnum[] = [...assignmentState.inspectionVisitUpdateRequest.auditedActivities]
                                            if (value && !newActTypes.includes(IVAuditedActivityEnum.BIO_SUISSE)) {
                                                newActTypes.push(IVAuditedActivityEnum.BIO_SUISSE)
                                            }
                                            else if (!value && newActTypes.includes(IVAuditedActivityEnum.BIO_SUISSE)) {
                                                newActTypes = newActTypes.filter(a => a !== IVAuditedActivityEnum.BIO_SUISSE)
                                            }
                                            dispatch(setIVUpdateAuditedActivities(newActTypes))
                                            setBioSuisseFlag(value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.33' }}>
                            <div className='text-left assignment-text-content'>
                                Tipo Visita
                            </div>
                            <SelectCustom
                                placeholder="Seleziona tipo..."
                                options={getOptions(assignmentState.getAssignmentByIdResponse?.norm!)}
                                value={assignmentState.inspectionVisitUpdateRequest.type}
                                onChange={(value) => dispatch(setIVUpdateType(value))}
                            />
                        </div>

                        <div style={{ flex: '0.33' }}>
                            <div className="text-left assignment-subtitle">
                                Attività
                            </div>
                            <SelectCustom
                                placeholder='Seleziona attività...'
                                options={IVActivityOptions}
                                value={assignmentState.inspectionVisitUpdateRequest.activity}
                                onChange={(value) => {
                                    dispatch(setIVUpdateActivity(value))
                                }}
                            />
                        </div>

                        <div style={{ flex: '0.33' }}>
                            <div className='text-left assignment-text-content'>
                                Modalità
                            </div>
                            <SelectCustom
                                placeholder="Seleziona modalità..."
                                options={IVModeOptions}
                                value={assignmentState.inspectionVisitUpdateRequest.mode}
                                onChange={(value) => dispatch(setIVUpdateMode(value))}
                            />
                        </div>
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Scadenza
                            </div>
                            <Calendar
                                selected={assignmentState.inspectionVisitUpdateRequest.expirationDate}
                                onChange={(date) => dispatch(setIVUpdateExpirationDate(format(new Date(date), 'yyyy-MM-dd')))}
                                onClear={(date) => dispatch(setIVUpdateExpirationDate(date))}
                            />
                        </div>

                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Data Scadenza prorogata al
                            </div>
                            <Calendar
                                selected={assignmentState.inspectionVisitUpdateRequest.expirationDateExtended}
                                onChange={(date) => dispatch(setIVUpdateExpirationDateExtended(format(new Date(date), 'yyyy-MM-dd')))}
                                onClear={(date) => dispatch(setIVUpdateExpirationDateExtended(date))}
                            />
                        </div>
                    </div>

                    {/* <div className='pb-5'>
                        <InfoBox
                            title='Dettaglio Controllo Straordinario/Mirato'
                            color='green'
                            freeText={{
                                title: null,
                                label: assignmentState.inspectionVisitUpdateRequest.controlDetail ?? ''
                            }}
                        />
                    </div> */}

                    <div className='pb-5' style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <div className='text-left assignment-text-content'>
                            Specifiche
                        </div>
                        <TextArea
                            value={assignmentState.inspectionVisitUpdateRequest.specification}
                            onChangeText={(text) => dispatch(setIVUpdateSpecification(text))}
                        />
                    </div>

                    <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Data prevista per il Controllo
                            </div>
                            <Calendar
                                selected={assignmentState.inspectionVisitUpdateRequest.plannedVisitDate}
                                onChange={(date) => dispatch(setIVUpdatePlannedVisitDate(format(new Date(date), 'yyyy-MM-dd')))}
                                onClear={(date) => dispatch(setIVUpdatePlannedVisitDate(date))}
                            />
                        </div>

                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Data effettiva del Controllo
                            </div>
                            <Calendar
                                selected={assignmentState.inspectionVisitUpdateRequest.effectiveVisitDate}
                                onChange={(date) => dispatch(setIVUpdateEffectiveVisitDate(format(new Date(date), 'yyyy-MM-dd')))}
                                onClear={(date) => dispatch(setIVUpdateEffectiveVisitDate(date))}
                            />
                        </div>
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Data Controllo da Remoto
                            </div>
                            <Calendar
                                selected={assignmentState.inspectionVisitUpdateRequest.visitDate}
                                onChange={(date) => dispatch(setIVUpdateVisitDate(format(new Date(date), 'yyyy-MM-dd')))}
                                onClear={(date) => dispatch(setIVUpdateVisitDate(date))}
                            />
                        </div>

                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Esito Controllo
                            </div>
                            <SelectCustom
                                placeholder="Seleziona esito..."
                                options={IVControlResultOptions}
                                value={assignmentState.inspectionVisitUpdateRequest.result}
                                onChange={(value) => dispatch(setIVUpdateResult(value))}
                            />
                        </div>
                    </div>

                    <div className="pb-5">
                        <div className='text-left assignment-text-content'>
                            Tipologia Non Conformità (di gravità maggiore)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona tipologia..."
                            options={IVNonComplianceTypeOptions}
                            value={assignmentState.inspectionVisitUpdateRequest.nonComplianceType}
                            onChange={(value) => dispatch(setIVUpdateNonComplianceType(value))}
                        />
                    </div>

                    <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <div className='text-left assignment-text-content'>
                            Note dell'ispettore
                        </div>
                        <TextArea
                            value={assignmentState.inspectionVisitUpdateRequest.instructorNote}
                            onChangeText={(text) => dispatch(setIVUpdateInstructorNote(text))}
                        />
                    </div>

                    <div className="pb-5 pt-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <div className='text-left assignment-text-content'>
                            Protocollo in Entrata del Verbale di Controllo
                        </div>
                        <ProtocolSearch
                            type="entry"
                            value={assignmentState.inspectionVisitUpdateRequest.reportProtocolId}
                            onSelect={(value) => dispatch(setIVUpdateReportProtocolId(value))}
                        />
                    </div>

                    <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Numero di giorni
                            </div>
                            <SelectCustom
                                placeholder="Seleziona numero..."
                                options={Array.from({ length: 15 }, (_, index) => {
                                    return { value: String(index + 1), label: String(index + 1) } as OptionType
                                })}
                                value={String(assignmentState.inspectionVisitUpdateRequest.daysNumber)}
                                onChange={(value) => dispatch(setIVUpdateDaysNumber(Number(value)))}
                            />
                        </div>
                        <div className="pb-3" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                            <div className='text-left assignment-text-content'>
                                Visita Effettuata in più giorni
                            </div>
                            <SingleCheckbox
                                label=''
                                checked={inMoreDaysFlag}
                                setChecked={(value) => {
                                    dispatch(setIVUpdateInMoreDays(value))
                                    setInMoreDaysFlag(value)
                                    if (!value && assignmentState.inspectionVisitUpdateRequest.startingEndingVisits.length > 0)
                                        dispatch(setIVUpdateStartingEndingVisits([assignmentState.inspectionVisitUpdateRequest.startingEndingVisits[0]]))
                                }}
                            />
                        </div>
                    </div>

                    <div className="pb-3">
                        <TableSelect
                            type="radio"
                            headers={['Data', 'Orario di Inizio Visita', 'Orario di Fine Visita']}
                            data={
                                assignmentState.inspectionVisitUpdateRequest.startingEndingVisits.map((sev, index) => {
                                    return {
                                        value: String(index),
                                        labels: [formatterDate(new Date(sev.split('@')[0]!)), sev.split('@')[1], sev.split('@')[2]]
                                    }
                                })
                            }
                            onChange={(value) => setVisitToEdit(value[0])}
                        />
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end', borderBottom: '1px solid #d9e6e8' }}>
                        <Button
                            disabled={visitToEdit === null}
                            variant="outline"
                            color="red"
                            iconPosition="left"
                            icon={<TrashIcon size={20} color="red" />}
                            label="Elimina visita"
                            size="md"
                            onClick={() => dispatch(setIVUpdateStartingEndingVisits(assignmentState.inspectionVisitUpdateRequest.startingEndingVisits.filter((sev, index) => String(index) !== visitToEdit)))}
                        />

                        <Button
                            disabled={visitToEdit === null}
                            variant="outline"
                            color="dimgrey"
                            iconPosition="left"
                            icon={<EditIcon size={20} color="" />}
                            label="Modifica Controllo"
                            size="md"
                            onClick={() => setShowPopupEdit(true)}
                        />

                        <Button
                            disabled={!inMoreDaysFlag && assignmentState.inspectionVisitUpdateRequest.startingEndingVisits.length > 0}
                            variant="solid"
                            color="dimgrey"
                            iconPosition="left"
                            icon={<RoundedPlusIcon />}
                            label="Aggiungi Controllo"
                            size="md"
                            onClick={() => setShowPopupAdd(true)}
                        />
                    </div>

                    <div className='pb-5 pt-5' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Soggetto in affiancamento
                            </div>
                            <Input
                                value={assignmentState.inspectionVisitUpdateRequest.inSupportSubject}
                                onChangeText={(text) => dispatch(setIVUpdateInSupportSubject(text))}
                            />
                        </div>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Ente
                            </div>
                            <Input
                                value={assignmentState.inspectionVisitUpdateRequest.inSupportSubjectEntity}
                                onChangeText={(text) => dispatch(setIVUpdateInSupportSubjectEntity(text))}
                            />
                        </div>
                    </div>

                    <div className='pb-5' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Soggetto in accompagnamento
                            </div>
                            <Input
                                value={assignmentState.inspectionVisitUpdateRequest.inAccompanyingSubject}
                                onChangeText={(text) => dispatch(setIVUpdateInAccompanyingSubject(text))}
                            />
                        </div>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Ente
                            </div>
                            <Input
                                value={assignmentState.inspectionVisitUpdateRequest.inAccompanyingSubjectEntity}
                                onChangeText={(text) => dispatch(setIVUpdateInAccompanyingSubjectEntity(text))}
                            />
                        </div>
                    </div>

                    <div className='pb-5' style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Soggetto esperto
                            </div>
                            <Input
                                value={assignmentState.inspectionVisitUpdateRequest.expertSubject}
                                onChangeText={(text) => dispatch(setIVUpdateExpertSubject(text))}
                            />
                        </div>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-content'>
                                Tecnico Tirocinante
                            </div>
                            <Input
                                value={assignmentState.inspectionVisitUpdateRequest.traineeTechnician}
                                onChangeText={(text) => dispatch(setIVUpdateTraineeTechniciant(text))}
                            />
                        </div>
                    </div>

                    <div className="pb-5 pt-5">
                        <div className="pb-3" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                            <div className='text-left assignment-text-content'>
                                Visita revocata
                            </div>
                            <SingleCheckbox
                                label=''
                                checked={isRevokedFlag}
                                setChecked={(value) => {
                                    dispatch(setIVUpdateIsRevoked(value))
                                    setIsRevokedFlag(value)
                                    if (!value)
                                        dispatch(setIVUpdateRevokedProtocolId(undefined))
                                }}
                            />
                        </div>
                        <div className="ml-[50px]">
                            <div className='text-left assignment-text-content'>
                                Protocollo Revoca Incarico
                            </div>
                            <ProtocolSearch
                                disabled={!isRevokedFlag}
                                type="entry"
                                value={assignmentState.inspectionVisitUpdateRequest.revokedProtocolId}
                                onSelect={(value) => dispatch(setIVUpdateRevokedProtocolId(value))}
                            />
                        </div>
                    </div>

                    <div className="pb-5 pt-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <div className="pb-3" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                            <div className='text-left assignment-text-content'>
                                Visita non espletata per recesso/esclusione
                            </div>
                            <SingleCheckbox
                                label=''
                                checked={isNotPerformedFlag}
                                setChecked={(value) => {
                                    dispatch(setIVUpdateIsNotPerformed(value))
                                    setIsNotPerformedFlag(value)
                                    if (!value) {
                                        dispatch(setIVUpdateExclusionProtocolId(undefined))
                                        dispatch(setIVUpdateExclusionDate(undefined))
                                    }
                                }}
                            />
                        </div>
                        <div className="ml-[50px]">
                            <div className="pb-5">
                                <div className='text-left assignment-text-content'>
                                    Data Recesso/Esclusione
                                </div>
                                <Calendar
                                    disabled={!isNotPerformedFlag}
                                    selected={assignmentState.inspectionVisitUpdateRequest.exclusionDate}
                                    onChange={(date) => dispatch(setIVUpdateExclusionDate(format(new Date(date), 'yyyy-MM-dd')))}
                                    onClear={(date) => dispatch(setIVUpdateExclusionDate(date))}
                                />
                            </div>
                            <div>
                                <div className='text-left assignment-text-content'>
                                    Protocollo Recesso/Esclusione
                                </div>
                                <ProtocolSearch
                                    disabled={!isNotPerformedFlag}
                                    type="entry"
                                    value={assignmentState.inspectionVisitUpdateRequest.exclusionProtocolId}
                                    onSelect={(value) => dispatch(setIVUpdateExclusionProtocolId(value))}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="pb-5 pt-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <div className="pb-3" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                            <div className='text-left assignment-text-content'>
                                Verbale restituito al Tecnico Ispettore per incompletezze sostenziali
                            </div>
                            <SingleCheckbox
                                label=''
                                checked={isReportReturnedFlag}
                                setChecked={(value) => {
                                    dispatch(setIVUpdateIsReportReturned(value))
                                    setIsReportReturnedFlag(value)
                                    if (!value) {
                                        dispatch(setIVUpdateRestitutionProtocolId(undefined))
                                        dispatch(setIVUpdateReturnedReportProtocolId(undefined))
                                    }
                                }}
                            />
                        </div>
                        <div className="ml-[50px]">
                            <div className="pb-5">
                                <div className='text-left assignment-text-content'>
                                    Protocollo restituzione
                                </div>
                                <ProtocolSearch
                                    disabled={!isReportReturnedFlag}
                                    type="entry"
                                    value={assignmentState.inspectionVisitUpdateRequest.restitutionProtocolId}
                                    onSelect={(value) => dispatch(setIVUpdateRestitutionProtocolId(value))}
                                />
                            </div>
                            <div>
                                <div className='text-left assignment-text-content'>
                                    Protocollo del verbale rientrato
                                </div>
                                <ProtocolSearch
                                    disabled={!isReportReturnedFlag}
                                    type="entry"
                                    value={assignmentState.inspectionVisitUpdateRequest.returnedReportProtocolId}
                                    onSelect={(value) => dispatch(setIVUpdateReturnedReportProtocolId(value))}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="pb-5 pt-5" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Verifica amministrativa effettuata
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={admVerificationFlag}
                            setChecked={(value) => {
                                dispatch(setIVUpdateAdministrativeVerification(value))
                                setAdmVerificationFlag(value)
                            }}
                        />
                    </div>

                    <div className="pb-5">
                        <div className='text-left assignment-text-content'>
                            Note
                        </div>
                        <TextArea
                            value={assignmentState.inspectionVisitUpdateRequest.note}
                            onChangeText={(text) => dispatch(setIVUpdateNote(text))}
                        />
                    </div>
                </div>
            </div>

            {
                (showPopupEdit && visitToEdit) && (
                    <PopupForm title="Modifica visita" headerGreen close={() => setShowPopupEdit(false)}>
                        <IVHoursPopupEdit close={() => setShowPopupEdit(false)} visitIndex={Number(visitToEdit)} />
                    </PopupForm>
                )
            }

            {
                showPopupAdd && (
                    <PopupForm title="Aggiungi visita" headerGreen close={() => setShowPopupAdd(false)}>
                        <IVHoursPopupAdd close={() => setShowPopupAdd(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}